import { useState } from 'react'
import { usePopper } from 'react-popper'
import { SimpleNotificationPopover } from '../my/SimpleNotificationPopover'

export type SimpleNotificationPopoverProps = {
  automaticCloseMs?: number
  offset?: [number, number]

  options?: {
    placement?:
      | 'auto'
      | 'auto-start'
      | 'auto-end'
      | 'top'
      | 'top-start'
      | 'top-end'
      | 'bottom'
      | 'bottom-start'
      | 'bottom-end'
      | 'right'
      | 'right-start'
      | 'right-end'
      | 'left'
      | 'left-start'
      | 'left-end'
  }
}

export const useSimpleNotificationPopover = ({
  automaticCloseMs,
  options,
  offset,
}: SimpleNotificationPopoverProps) => {
  const [open, setOpen] = useState<boolean>(false)

  const closeNotification = (event: any) => {
    event.stopPropagation()
    event.preventDefault()
    setOpen(() => false)
  }
  const openNotification = () => {
    setOpen(true)
    if (automaticCloseMs) {
      setTimeout(() => setOpen(false), automaticCloseMs)
    }
  }

  const [referenceElement, setReferenceElement] = useState<any>()
  const [popperElement, setPopperElement] = useState()
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    strategy: 'fixed',
    ...options,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: offset,
        },
      },
    ],
  })
  return {
    NotificationPopoverComponent: SimpleNotificationPopover,
    notificationPopoverProps: {
      setOpen,
      open,
      setPopperElement,
      styles,
      attributes,
    },
    openNotification,
    closeNotification,
    setReferenceElement,
  }
}
